<div class="icons">
  <img pTooltip="Informações referentes aos últimos registros de cada tipo de dado" src="/assets/icons/Vectorinfo.svg"/>
  <img *ngIf="showCamera"  (click)="openVideo()" src="/assets/icons/camera.svg" />
  <!-- <img *ngIf="showBoard" (click)="showDialog()" src="/assets/icons/bookMark.svg" /> -->
</div>
